import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { Form, FormItem, Input, Loading, Button, Drawer, Dialog, Slider, DatePicker, Dropdown, DropdownMenu, DropdownItem, InputNumber, Autocomplete, Checkbox, CheckboxGroup, Switch, Tooltip, MessageBox, Message, Table, TableColumn, ColorPicker, Notification, Popover } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/it'
import locale from 'element-ui/lib/locale'
import { library } from '@fortawesome/fontawesome-svg-core'
import { dom } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown, faAngleRight, faAngleLeft, faChartPie, faTimes, faEnvelopeOpen, faQrcode, faSyncAlt, faBars, faEdit, faTrashAlt, faArrowsAlt, faPlus, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VCalendar from 'v-calendar'
import Unicon from 'vue-unicons'
import { uniTrashAlt, uniTrash, uniBookMedical, uniCreateDashboard, uniSlidersVAlt, uniClipboardNotes, uniAngleRightB, uniCalendarAlt, uniSearch, uniFileEditAlt, uniKeySkeleton, uniExclamationTriangle, uniCheckCircle, uniInvoice, uniEllipsisV, uniDraggabledots, uniEllipsisH, uniAngleDoubleDown, uniAngleLeftB, uniAngleDown, uniTimes, uniAngleDoubleRight, uniSave, uniUsersAlt, uniUserPlus, uniUserCheck, uniUserExclamation, uniJackhammer, uniQrcodeScan, uniThumbsUp, uniPlusCircle, uniTimesCircle, uniFilePlusAlt, uniDownloadAlt, uniBell, uniMegaphone, uniEnvelopeShare, uniReceipt, uniEuro, uniQuestionCircle, uniEuroCircle, uniMoneyBill, uniMoneyBillSlash, uniSignOutAlt, uniArrowLeft, uniBookReader, uniLink } from 'vue-unicons/src/icons'
import { nanoid } from 'nanoid'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueSocketIO from 'vue-socket.io'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Vue.use(new VueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_SOCKET,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
    // options: { path: "/my-app/" } //Optional options
}))
Vue.component(VueQrcode.name, VueQrcode)
Unicon.add([uniTrashAlt, uniTrash, uniBookMedical, uniCreateDashboard, uniSlidersVAlt, uniClipboardNotes, uniAngleRightB, uniCalendarAlt, uniSearch, uniFileEditAlt, uniKeySkeleton, uniExclamationTriangle, uniCheckCircle, uniInvoice, uniEllipsisV, uniDraggabledots, uniEllipsisH, uniAngleDoubleDown, uniAngleLeftB, uniAngleDown, uniTimes, uniAngleDoubleRight, uniSave, uniUsersAlt, uniUserPlus, uniUserCheck, uniUserExclamation, uniJackhammer, uniQrcodeScan, uniThumbsUp, uniPlusCircle, uniTimesCircle, uniFilePlusAlt, uniDownloadAlt, uniBell, uniMegaphone, uniEnvelopeShare, uniReceipt, uniEuro, uniQuestionCircle, uniEuroCircle, uniMoneyBill, uniMoneyBillSlash, uniSignOutAlt, uniArrowLeft, uniBookReader, uniLink])
Vue.use(Unicon, {
	fill: '#333',
	height: 20,
	width: 20
})

Vue.config.productionTip = false

locale.use(lang)

Vue.use(VCalendar, {
  componentPrefix: 'vc'  // Use <vc-calendar /> instead of <v-calendar />
})

Vue.use(nanoid)

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Button)
Vue.use(Drawer)
Vue.use(Dialog)
Vue.use(Slider)
Vue.use(DatePicker)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(InputNumber)
Vue.use(Autocomplete)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(ColorPicker)
Vue.use(Popover)
// Vue.use(Message)
// Vue.use(MessageBox)
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

library.add(faAngleDown, faAngleRight, faAngleLeft, faChartPie, faTimes, faEnvelopeOpen, faWhatsapp, faFacebookSquare, faInstagram, faQrcode, faSyncAlt, faBars, faEdit, faTrashAlt, faArrowsAlt, faPlus, faTimesCircle)
// locale.use(lang)
dom.watch()
Vue.component('font-awesome-icon', FontAwesomeIcon)

const messages = {
  it: {
    message: {
      hello: 'hello world',
      ombrid: 'ID Ombrellone',
      room: 'Stanza',
      stay: 'Soggiorno',
      guest: 'Nome ospite',
      items: 'Oggetti Ombrellone'
    }
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'it', // set locale
  messages, // set locale messages
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
